import "./showdocument.scss";
import { Modal } from "react-bootstrap";
import cross from "images/cross.svg";

import { inject, observer } from "mobx-react";

const ShowDocument = ({ documentUrl, ...props }) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      aria-labelledby="contained-modal-title-vcenter"
      size="xl"
      centered
      contentClassName="showDocument-content"
      dialogClassName="showDocument-dialog"
      backdrop="static"
    >
      <Modal.Body className="showDocument">
        <p>
          <img
            src={cross}
            className="signin-img"
            onClick={props.onHide}
            alt=""
          />
        </p>
        {documentUrl !== false ? (
          <div className="showDocument-onedocument-wrapper">
            {documentUrl.slice(documentUrl.length - 2) != "-1" ? (
              <>
                {documentUrl.includes("pdf") ? (
                  <object
                    data={documentUrl}
                    type="application/pdf"
                    title="Document"
                  />
                ) : (
                  <img
                    className="showDocument-onedocument"
                    src={documentUrl}
                    alt=""
                  />
                )}
              </>
            ) : (
              "Извините, такого файла не существует"
            )}
          </div>
        ) : (
          ""
        )}
        {props.plugnodoc && !documentUrl ? (
          <div className="plug-no-doc">
            <h6 className="mb-3 text-center">Документ</h6>
            <p className="m-0 text-center">
              {`Здесь будет документ ${props.plugnodoc}.`}
            </p>
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ filesStore }) => {
  const { documentUrl } = filesStore;
  return {
    documentUrl
  };
})(observer(ShowDocument));
